import CitySelectContainer from './city-select-container';

export default CitySelectContainer;
